const animations = {
  defaultTransition: `all ease-in-out 350ms`,
};

export default animations;
